import React from 'react';
import FieldLayout from '@blockcatio/tabby-library/lib/components/form/FieldLayout';

class AdvancedOptionsLayout extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
    };

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick() {
    const { isOpen } = this.state;
    this.setState({ isOpen: !isOpen });
  }

  render() {
    return (
      <div className={`${this.state.isOpen ? 'open' : 'closed'} advanced-options`}>
        <button type="button" className="toggle" onClick={this.handleClick}>Advanced Options</button>
        <FieldLayout {...this.props} />
      </div>
    );
  }
}

AdvancedOptionsLayout.displayName = 'AdvancedOptionsLayout';

export default AdvancedOptionsLayout;



// WEBPACK FOOTER //
// ./src/components/AdvancedOptionsLayout.js